function Aggregator_wrapper_form_container_edit(element) {
	this.$element = $(element);
	this.popup = i4_Popup.get(this.$element);
	
	this.data = {
		containerID: 'container-id',
	    imageDelete: 'image-delete'
	};

	this.init = function() {
		
		// console.log('Aggregator_wrapper_form_container_edit - init()');
		
		this.dataContainerID = this.$element.data(this.data.containerID);
	    this.dataImageDelete = this.$element.data(this.data.imageDelete);
	    
		this.initListEditor();
	};

	this.initListEditor = function() {
		
		i4_List_editor.get('aggregator_wrapper_container_edit').
			set_element_result_id('list_variants_result').
			set_ajax_parameter({
			    js: 'aggregator_wrapper',
			    call: 'variants_list_edit',
			    container_id: this.dataContainerID
			}).
			set_option({
				sortable: false,
				image_delete: this.dataImageDelete, 
				image_move: this.dataImageMove,
				after_delete_item: (function() {
					this.popup.set_layout().renew_position();
				}).bind(this),
				after_add_item: (function() {
					this.popup.set_layout().renew_position();
				}).bind(this),
				after_load: (function() {
					this.popup.set_layout().renew_position();
				}).bind(this)
			}).
			run();
	};

}